import { TriggerEvent } from "floating-vue";

const isTouchScreen = navigator.maxTouchPoints > 0;
const defaultTooltipTriggers: TriggerEvent[] = isTouchScreen ? ["focus", "click"] : ["hover"];

async function copyText(text: string) {
	return await navigator.clipboard.writeText(text);
}

export { isTouchScreen, defaultTooltipTriggers, copyText };
